import { render, staticRenderFns } from "./CultureDesignMaterialYearInfo.vue?vue&type=template&id=539b3941&scoped=true&"
import script from "./CultureDesignMaterialYearInfo.vue?vue&type=script&lang=js&"
export * from "./CultureDesignMaterialYearInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b3941",
  null
  
)

export default component.exports